<p-dialog
  [(visible)]="display"
  header="{{ ThreadTopicEnum[topicId] }} {{ 'label.AddComment' | translate }}"
  (onHide)="onCancel()"
  appendTo="body"
  modal="true"
  width="400"
>
  <div>
    <textarea [(ngModel)]="text" maxlength="500"></textarea>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onSave()"
      label="{{ 'label.Save' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
